const DEFAULT_TRANSLATION_KEY = "_default"

export interface PreferenceCenterTranslation {
  submitButtonText: string

  /** state messages */
  loading: string

  /** success messages */
  successSavingPreferences: string

  /** error messages */
  errorLoadingPreferenceCenter: string
  errorSavingPreferences: string
}

export interface EmailPreferenceCenterTranslation
  extends PreferenceCenterTranslation {
  unsubscribeButtonText: string
}

const defaultEmailPreferenceCenterTranslation: EmailPreferenceCenterTranslation = {
  submitButtonText: "Save communication preferences",
  loading: "Loading…",
  unsubscribeButtonText: "Unsubscribe from all emails",
  successSavingPreferences: "Your preferences have been saved.",
  errorLoadingPreferenceCenter:
    "There was an error loading this preference center. Please try again.",
  errorSavingPreferences:
    "There was an error saving your preferences. Please try again.",
}

export function getEmailPreferenceCenterTranslation(
  overrides: { [key: string]: Partial<EmailPreferenceCenterTranslation> },
  locale?: string
): EmailPreferenceCenterTranslation {
  return {
    ...defaultEmailPreferenceCenterTranslation,
    ...overrides[locale ?? DEFAULT_TRANSLATION_KEY],
  }
}
